import BoltIcon from '@mui/icons-material/Bolt';
import MyLocationIcon from '@mui/icons-material/MyLocation';
import SignalCellularAltIcon from '@mui/icons-material/SignalCellularAlt';
import type { SvgIconProps } from '@mui/material/SvgIcon';
import { alpha } from '@mui/material/styles';
import { palette } from '@openx/components-core/lib/theme/paletteV2';
import type { TFunction } from 'i18next';
import type { ComponentType } from 'react';
import {
  type DealPromptContextType,
  type DealPromptIcon,
  dealPromptContextTypes,
  dealPromptIcons,
  type ResultsTileBadge,
} from '../../utils/types';

export const iconsMap: Record<Exclude<DealPromptIcon, 'domains' | 'apps' | 'audience'>, ComponentType<SvgIconProps>> = {
  [dealPromptIcons.SCALE]: SignalCellularAltIcon,
  [dealPromptIcons.RELEVANCE]: MyLocationIcon,
  [dealPromptIcons.PERFORMANCE]: BoltIcon,
};

export const iconColorsMap: Record<Exclude<DealPromptContextType, 'all'>, string> = {
  [dealPromptContextTypes.DOMAINS]: palette.charts.indigo,
  [dealPromptContextTypes.APPS]: palette.charts.blue,
  [dealPromptContextTypes.AUDIENCE]: palette.charts.magenta,
};

export const getTileSubtitlesMap = (t: TFunction): Record<Exclude<DealPromptContextType, 'all'>, string> => ({
  [dealPromptContextTypes.DOMAINS]: t('Domains'),
  [dealPromptContextTypes.APPS]: t('Apps'),
  [dealPromptContextTypes.AUDIENCE]: t('Audience'),
});

export const getBadgeConfig = (contextType: Exclude<DealPromptContextType, 'all'>, t: TFunction): ResultsTileBadge => ({
  text: getTileSubtitlesMap(t)[contextType],
  color: iconColorsMap[contextType],
  bgColor: alpha(iconColorsMap[contextType], 0.16),
});
